import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0f10bb60"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "resolution-selector" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_udc_select = _resolveComponent("udc-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_udc_select, {
      modelValue: _ctx.current,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.current) = $event)),
      options: _ctx.options
    }, null, 8, ["modelValue", "options"])
  ]))
}